import axios from "axios"
export const ERROR_OK = 0

//公用的请求环境
console.log(process.env.VUE_APP_API_SERVER, "ffff")
axios.defaults.baseURL =
  process.env.NODE_ENV === "production" ? "/api" : "/api"
axios.defaults.timeout = 15000
axios.interceptors.request.use(
  config => {
    config.headers["Content-Type"] = "application/json;charset=utf-8"
    return config
  },
  error => {
    Promise.error(error)
  }
)
//响应拦截
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return response
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    return Promise.reject(error.response)
  }
)

//get请求封装
export function get (url, params) {
  return axios
    .get(url, {
      params
    })
    .then(res => {
      return res.data
    })
    .catch(err => {
      return err
    })
}
export function post (url, data) {
  console.log(url, data)
  return axios({
    method: "post",
    url,
    data
  })
    .then(res => {
      if (res.data.code === 403) {
        return Promise.reject(res)
      }
      return res.data
    })
    .catch(err => {
      return err
    })
}
